import { jsx as o, jsxs as f } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { FormToggle as h } from "../FormToggle/FormToggle.js";
import { switchVariants as u } from "./Switch.variants.js";
const r = u, N = p(
  ({
    disableAnimation: c = !1,
    isDisabled: t = !1,
    isInvalid: s = !1,
    ...e
  }, n) => {
    const l = r.control(), m = r.input({ isDisabled: t }), a = r.container({
      disableAnimation: c,
      isDisabled: t,
      isInvalid: s
    });
    return /* @__PURE__ */ o(h, { isDisabled: t, isInvalid: s, ...e, children: (i) => /* @__PURE__ */ f("div", { className: l, children: [
      /* @__PURE__ */ o(
        "input",
        {
          ...i,
          className: m,
          ref: n,
          role: "switch",
          type: "checkbox"
        }
      ),
      /* @__PURE__ */ o("div", { className: a })
    ] }) });
  }
);
export {
  N as Switch
};
